import { EmailLayout, type EmailLayoutProps } from '@/app/components/layout';
import { Partner } from '@/configs/partner';

import HelpLink from './HelpLink';

interface Props {
  readonly title: EmailLayoutProps['title'];
  readonly description: EmailLayoutProps['description'];
  readonly note?: EmailLayoutProps['note'];
  readonly isInvalid?: EmailLayoutProps['isInvalid'];
  readonly isMaintenance?: EmailLayoutProps['isMaintenance'];
}

const BusinessEmailLayout = ({
  title,
  description,
  note,
  isInvalid = false,
  isMaintenance = false,
}: Props) => {
  return (
    <EmailLayout
      title={title}
      description={description}
      note={note}
      help={<HelpLink standalone />}
      imageSrc="/partnerships/or5/or5-silver-pond.jpg"
      partner={Partner.business}
      isInvalid={isInvalid}
      isMaintenance={isMaintenance}
    />
  );
};

export default BusinessEmailLayout;
